import React from "react";
import Image from "react-bootstrap/Image";
import Media from "react-media";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

export const MainBusinessHoursHome = ({ onClickHome, handleFormHide }) => {
  return (
    <React.Fragment>
      <div>
        <div className="col-12 p-0 ">
          {/* cuisine-setup-home-div */}
          {/* <h4 className="business-hours-main-home-heading">
            Business and Hours of Operations
          </h4>
          <div> */}
          {/* <TopTextReusableComponent headingText="Business and Hours of Operations" /> */}
          {/* </div> */}
          {/* <Image
            src={require("../../../../assets/images/onboarding/storeSetup4.png")}
            alt="Cuisine Setup"
            title="Cuisine Setup"
            fluid
            className="business-hours-main-image"
          /> */}
          <div className="f24_700_HelveticaNeue">
            Business and Hours of Operations
          </div>
          <h4 className="f14-700 pt-5 pb-3">
            Key Points about you that Customers Must Be Aware Of:{" "}
          </h4>
          <div className="f11-400 opacity5">
            (Please enter information about your Business Hours of Operation.)
          </div>
          <div
            style={{ height: "52vh", maxWidth: 500 }}
            className="business-hours-main-home-section margin-bottom-chains-onboarding mb-4 mt-3"
          >
            <p className="f12-400">
              Mention your restaurant's working hours so that users know when
              you're open, such as whether you're open 24 hours a day or what
              your business hours are during the week.
            </p>
            <br />
            <p className="f12-400">
              Keep the opening/closing status of your restaurant up to date so
              that the users can get a clear picture about when to order.
            </p>
            <br />
            <p className="f12-400">
              Put in your restaurant working hours in advance for the week, for
              easy access and transparency for users so that they can plan when
              to order the food from your outlet.
            </p>
            <br />
            <p className="f12-400">
              You can preset your break times so that users can see when the
              restaurant closes and reopens, allowing them to order ahead of
              time or look up the restaurant's operating hours and place their
              orders appropriately.
            </p>
            <br />
            <p className="f12-400">
              You can setup multiple sessions of opening hours, e.g. preset
              timings for breakfast, lunch, dinner, etc.
            </p>
          </div>
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button ">
          <Media query="(min-width: 992px)">
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link="/multicuisine"
            />
          </Media>
          <Media query="(max-width: 992px)">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
              buttonText="Back"
              buttonType="button"
              onClick={handleFormHide}
            />
          </Media>
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onClickHome}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
